import { useCallback, useEffect, useRef, useState } from "react";
import { getTags } from "../../services/communityService";
import { ApiArrayResponseModel } from "./models/ApiResponseModel";
import { TagsResultModel } from "./models/TagsResultModel";
import { useSearch } from "./useSearch";

const defaultValue = {
    results: [], 
    count: 0, 
    next: null, 
    previous: null,
}

export const useSuggestTags = (search: string) => {
    const isMountedRef = useRef(true);
    const [tags, setTags] = useState<ApiArrayResponseModel<TagsResultModel>>(defaultValue);
    const searchValue = useSearch(search, 500);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    const load = useCallback(async () => {
        try {
            const _tags = await getTags(searchValue);
            if (!isMountedRef.current) 
                return;
            setTags(_tags);
        } 
        catch (e) { }
    }, [searchValue]);

    useEffect(() => {
        load();
    }, [load]);

    return { tags };
}